"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILIconTile = void 0;
var react_1 = __importDefault(require("react"));
var il_custom_icon_1 = require("../il-custom-icon/il-custom-icon");
var material_1 = require("@mui/material");
var il_highlight_tile_1 = require("../il-highlight-tile/il-highlight-tile");
var ILIconTile = function (props) {
    var sx = props.sx, iconSize = props.iconSize, iconColor = props.iconColor, other = __rest(props, ["sx", "iconSize", "iconColor"]);
    return (react_1.default.createElement(il_highlight_tile_1.ILHighlightTile, __assign({ sx: __assign({ width: '9.75rem', height: '9.75rem' }, sx) }, other),
        props.type && (react_1.default.createElement(il_custom_icon_1.ILCustomIcon, { icon: props.icon, type: props.type, backgroundColor: iconColor, size: iconSize })),
        react_1.default.createElement(material_1.Typography, { sx: {
                fontSize: '18px',
                fontWeight: '600',
                lineHeight: 1.33,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                color: 'text.primary',
                mt: 1.5,
                height: '3.25rem',
            } }, props.children)));
};
exports.ILIconTile = ILIconTile;
